import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import MainWrapper from "../../helpers/MainWrapper";
import MainHeader from "./MainHeader";
import BusinessCourierBrand from "./BusinessCourierBrand";
import WhySection from "./WhySection";
import LinksSection from "./LinksSection";
import ContactSection from "./ContactSection";
import "./styles.less";

declare var root: any;

const BusinessPage = () => {
  return (
    <>
      <MainWrapper menus={true}>
        <MainHeader />
        <BusinessCourierBrand />
        <WhySection />
        <LinksSection />
        <ContactSection />
      </MainWrapper>
    </>
  );
};

if (root) {
  ReactDOM.render(<BusinessPage />, root);
}
